export const api = {
  members: '/member-list',
  memberTabs: '/member/tabs',
  memberPlacementTree: '/member-placement-tree',
  memberDetail: '/member-details',
  memberPasswordReset: '/password/send-reset-notification-by-user',
  memberDetails: '/member-details',
  member: '/member',
  memberPlacementOuterTree: '/member-placement-tree-outer',
  memberTree: '/sponsor-downline-listing',
  memberRankUpdate: '/member-ranks',
  memberRankList: '/member-ranks-list',
  memberHighestRank: '/team-bonus-ranks-list',
  memberEnrollmentRank: '/enrollment-ranks-list',
  memberMigrationList: '/member-migrate-list',
  memberMigrationUpdate: '/member-migrate',
  memberStatusList: '/member-status-list',
  memberStatusUpdate: '/member-status',
  memberWalletTransactions: '/ewallet/transactions',
  memberSalesHistory: '/member/sales-history',
  memberOnBehalfToken: '/login-as/',
  memberSubscription: '/sales/create-member-subscription',
  memberNextPlacement: '/commission/placement-preference/',
  memberCouncilRankList: '/council/council-rank',
  memberPerformance: '/downline-member-performance',
  memberPerformanceDownload: '/downline-member-performance-download',
  memberSponsorDownlineListing: '/sponsor-listing',
  memberSponsorDownlineListingFilters: '/sponsor-listing-filters',
  memberSponsorDownlineListingReport: '/sponsor-listing-report',
}
